export default "__VITE_ASSET__25_N9FLk__"